import module from 'module';
import StatusBasedService from "./statusBasedService";

module.factory('informationMessageService', (statusService) =>
  new StatusBasedService({
    property: 'informationMessage',
    statusService: statusService,
    optional: true
  }));